import { AnyAction } from '@reduxjs/toolkit';

export function makeEnhancedMatcher<A extends AnyAction>(
  matcher: (action: AnyAction) => action is A,
  predicate: (action: A) => boolean,
) {
  return (action: AnyAction): action is A => matcher(action) && predicate(action);
}
